import { faCheck } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  JoonUIColor,
  Modal,
  ModalHeader,
  Typography,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import useSettingsLanguageModalStore from "./hooks/useSettingsLanguageModalStore"
import {
  changeLanguage,
  Language,
  LANGUAGE_NAMES,
  SUPPORTED_LANGUAGES,
} from "../../locales/i18n"

const SettingsLanguageModal = () => {
  const { isOpen, onClose } = useSettingsLanguageModalStore()
  const { t, i18n } = useTranslation()
  // `useTranslation` re-renders on language change, so this stays in sync with the
  // selection without any local state of its own.
  const activeLanguage = i18n.resolvedLanguage

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      animate
      mobileFull
      style={{ width: "min(450px, 100vw)" }}
    >
      <ModalHeader
        title={t("LANGUAGE_TITLE")}
        onClose={onClose}
        showBorderBottom
      />
      <div className="flex flex-col gap-4 p-6 pt-4">
        <Typography variant="bodySmall" color={JoonUIColor.text.secondary}>
          {t("LANGUAGE_DESCRIPTION")}
        </Typography>
        <div className="flex flex-col rounded-lg overflow-hidden border border-borderPrimary">
          {SUPPORTED_LANGUAGES.map((language, index) => (
            <LanguageOption
              key={language}
              language={language}
              isSelected={language === activeLanguage}
              isLastItem={index === SUPPORTED_LANGUAGES.length - 1}
              onClick={() => changeLanguage(language)}
            />
          ))}
        </div>
      </div>
    </Modal>
  )
}

const LanguageOption = ({
  language,
  isSelected,
  isLastItem,
  onClick,
}: {
  language: Language
  isSelected: boolean
  isLastItem: boolean
  onClick: () => void
}) => {
  return (
    <button onClick={onClick} lang={language}>
      <div
        className={`flex items-center gap-3 p-3 pr-4 w-full bg-white hover:bg-bgXLightGray ${
          isLastItem ? "" : "border-b border-borderPrimary"
        }`}
      >
        <Typography variant="body" textAlign="left">
          {LANGUAGE_NAMES[language]}
        </Typography>
        {isSelected && (
          <FontAwesomeIcon
            icon={faCheck}
            fontSize={16}
            color={JoonUIColor.icon.accent}
            className="ml-auto"
          />
        )}
      </div>
    </button>
  )
}

export default SettingsLanguageModal
